export default {
  data () {
    return {
      isMounted: false
    }
  },
  computed: {
    _isPreRender () {
      return (window['__PRERENDER_INJECTED'] || {}).rendering
    }
  },
  mounted () {
    this.isMounted = true
  },
  methods: {
    _checkRendered () {
      let conditions = Object.entries(this.renderWhen || {})
      let results = conditions.map(([key, value]) => this[key] === value )

      if (conditions.length === 0 ) return this._emitRender()

      if (results.every(r => r)) {
        this._emitRender()
      } else {
        setTimeout(() => {this._checkRendered()}, 500)
      }
    },
    _emitRender () {
      setTimeout(() => {
        document.dispatchEvent(new Event('ready-to-render'))
      }, 100)
    }
  },
  watch: {
    isMounted () {
      this._checkRendered()
    }
  }
}